import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  margin-left: 20px;
  z-index: 10;
  background: transparent; 
  box-sizing: border-box;
`;

const Logo = styled.img`
  width: 50px;  /* Largura da logo */
  height: auto; /* Mantém a proporção */
  margin-left: 25px; /* Espaçamento entre as logos */
  background-color: transparent; /* Corrija esta linha */



  &.ppgp-logo {
    margin-top: 25px; /* Ajuste o valor conforme necessário */
  }
`;

const Header = () => {
  return (
    <HeaderContainer>
      <Logo className='ufsc-logo' src="./UFSC.png" alt="Logo 1" />
      <Logo className = 'ppgp-logo' src="./ppgpenf.png" alt="Logo 2" />
    </HeaderContainer>
  );
};

export default Header;
